export const OVERALL_PERFORMANCE_TYPE_REQUEST = 'OVERALL_PERFORMANCE_TYPE_REQUEST';
export const OVERALL_PERFORMANCE_TYPE_SUCCESS = 'OVERALL_PERFORMANCE_TYPE_SUCCESS';
export const OVERALL_PERFORMANCE_TYPE_FAIL = 'OVERALL_PERFORMANCE_TYPE_FAIL';

